module.exports = __webpack_public_path__ + "static/vicki-vasques-7ad415128eac8932deb22d4aca704887.jpg";